<template>
  <div>
    <div v-if="loading_page === true">
      <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
        <v-skeleton-loader type="article, actions"></v-skeleton-loader>
      </v-sheet>
    </div>
    <div v-else>
      <div class="ma-2">
        <v-card elevation="6">
          <div class="pa-4">
            <QuotationNumber :quotation_code="header_list.quotation_code" :quotation_date="date"/>
            <div class="mt-4">
              <div class="grid_contact">
                <div class="grid_flex mt-2">
                  <div class="mr-2">เบอร์โทร</div>
                  <div class="grey--text">{{ header_list.telephone }}</div>
                </div>
                <div class="grid_flex mt-2">
                  <div class="mr-2">ชื่อลูกค้า</div>
                  <div class="grey--text">{{ header_list.customer_name }}</div>
                </div>
              </div>
              <div class="grid_contact">
                <div class="grid_flex mt-2">
                  <div class="mr-2">ที่อยู่</div>
                  <div class="grey--text">{{ header_list.address }}</div>
                </div>
              </div>
              <div class="grid_address mt-2">
                <div>
                  <div>ตำบล/แขวง</div>
                  <div class="grey--text">{{ header_list.sub_district }}</div>
                </div>
                <div>
                  <div>อำเภอ/เขต</div>
                  <div class="grey--text">{{ header_list.district }}</div>
                </div>
                <div>
                  <div>จังหวัด</div>
                  <div class="grey--text">{{ header_list.province }}</div>
                </div>
                <div>
                  <div>รหัสไปรษณีย์</div>
                  <div class="grey--text">{{ header_list.postcode }}</div>
                </div>
              </div>
              <div class="grid_contact">
                <div class="grid_flex mt-2">
                  <div class="mr-2">การจัดส่ง</div>
                  <div class="grey--text">{{ header_list.delivery_type == 1 ? 'ส่งพัสดุ' : 'รับที่ร้าน'}}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="pa-4">
            <v-card-title>
              รายการสินค้า
            </v-card-title>
            <div v-if="loading_data === true">
              <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
              </v-sheet>
            </div>
            <div v-else>
              <v-data-table :headers="headers" :items="data_list" key="index" :footer-props="footer_Props" mobile-breakpoint="0" hide-default-footer>
                <template slot="item" slot-scope="dataDetail">
                  <tr>
                    <td>{{ dataDetail.index + 1 }}</td>
                    <td>{{ dataDetail.item.product_name }}</td>
                    <td>{{ dataDetail.item.unit_name }}</td>
                    <td>{{ dataDetail.item.qty }}</td>
                    <td>{{ formatPrice(dataDetail.item.price) }}</td>
                    <td>{{ formatPrice(dataDetail.item.total) }}</td>
                  </tr>
                </template>
                <template v-slot:body.append>
                  <tr>
                    <td colspan="5" class="text-center">ค่าจัดส่ง</td>
                    <td>{{ formatPrice(header_list.delivery_price) }}</td>
                  </tr>
                  <tr>
                    <td colspan="5" class="text-center">จำนวนเงินรวม</td>
                    <td>{{ formatPrice(header_list.total) }}</td>
                  </tr>
                </template>
              </v-data-table>
              <v-divider/>
            </div>
            <div class="grid_flex mt-2">
              <div class="mr-2">หมายเหตุ :</div>
              <div>{{ header_list.note }}</div>
            </div>
          </div>
          <div class="ma-4">
            <div class="lc_flex">
              <div class="pa-2">
                <div class="ml-1 mb-5">กรุณาเซ็นยืนยันการสั่งซื้อ</div>
                <div>..................................................................</div>
                <div>วันที่................./................./.................</div>
              </div>
              <div class="pa-2">
                <div class="mb-5">บริษัท ฟาร์มาร์แคร์ พลัส จำกัด</div>
                <div>..................................................................</div>
                <div>วันที่................./................./.................</div>
              </div>
            </div>
          </div>
          <div class="text-center pa-3">
            <v-btn large @click="getEdit" class="white--text grad-warning-bg mobile_btn" style="font-size: 18px" type="button">
              <v-icon>mdi-note-edit-outline</v-icon>แก้ไขข้อมูล</v-btn>
            <v-btn large @click="getPrinter" class="white--text grad-main-bg mobile_btn" style="font-size: 18px" type="button">
              <v-icon>mdi-printer</v-icon>พิมพ์</v-btn>
          </div>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import QuotationNumber from "@/components/admin/stock/quotation/header_quotation/QuotationNumber";
import {HTTP} from "@/axios";
export default {
  components: {QuotationNumber},
  inject: {
    theme: {
      default: {
        isDark: false
      },
    },
  },
  name: "Quotation_detail",
  data() {
    return {
      loading_page: false,
      loading_data: false,
      date: '',
      footer_Props: {
        // showFirstLastPage: true,
        // firstIcon: 'mdi-arrow-collapse-left',
        // lastIcon: 'mdi-arrow-collapse-right',
        // prevIcon: 'mdi-minus',
        // nextIcon: 'mdi-plus',
        'items-per-page-text':'รายการต่อหน้า'
      },
      headers: [
        {
          text: 'ลำดับ',
          value: 'id',
          fixed: true,
          width: '140px',
        },
        {
          text: 'รายละเอียดสินค้า',
          value: 'product_name',
          fixed: true,
          width: '250px',
        },
        {
          text: 'หน่วยนับ',
          value: 'name',
          fixed: true,
          width: '150px',
        },
        {
          text: 'จำนวน',
          value: 'qty',
          fixed: true,
          width: '180px',
        },
        {
          text: 'หน่วยละ',
          value: 'price',
          fixed: true,
          width: '200px',
        },
        {
          text: 'จำนวนเงิน',
          value: 'total',
          fixed: true,
          width: '200px',
        },
      ],
      data_list: [],
      header_list: [],
    }
  },
  methods: {
    formatPrice(value) {
      let val = (value/1).toFixed(2).replace(',', '.')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    },
    diffDateTH(value) {
      const diff = value.split('-')
      const day = diff[2]
      const month = diff[1]
      const year = parseInt(diff[0])+ 543
      const final_date = day+'/'+month+'/'+year
      return this.date = final_date
    },
    getDetail() {
      this.loading_page = true
      this.loading_data = true
      HTTP.post('/quotations/viewquotation', {
        quotation_id: this.$route.params.id
      }).then((res) => {
        if (res.data.success === true) {
          this.loading_page = false
          this.loading_data = false
          this.header_list = res.data.quotation
          if (res.data.quotation.date !== null) {
            this.date = res.data.quotation.date
            this.diffDateTH(this.date)
          }
          else {
            this.date = ''
          }
          this.data_list = res.data.quotationlists
        }
      })
    },
    getEdit() {
      const id = this.$route.params.id
      this.$router.push('/stock/quotation/quotationedit/' + id)
    },
    getPrinter() {
      const id = this.header_list.id
      window.open('https://www.pharmacare-plus.com/quotationpdf?id=' + id, '_blank')
    },
  },
  computed: {
    total() {
      let data_list = this.data_list;
      const result = data_list.reduce((sum, number) => {
        let total_price = number.qty * parseInt(number.price);
        if (total_price < 0) {
          return sum+(0);
        }
        else {
          return sum+(total_price);
        }
      }, 0)
      return result.toFixed(2).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted() {
    this.getDetail()
  }
}
</script>

<style scoped>
.grid_flex {
  display: flex;
}
.grid_contact {
  display: grid;
  grid-template-columns: 50% 50%;
}
.grid_address {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}
.lc_flex {
  display: flex;
  justify-content: space-around;
}
.mobile_btn {
  width: 25%;
  margin: 15px;
}
@media only screen and (max-width: 1180px) {
  .grid_flex {
    display: block;
  }
  .grid_contact {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .grid_address {
    display: grid;
    grid-template-columns: 25% 25% 25% 25%;
    grid-gap: 15px 0;
  }
  .mobile_btn {
    width: 40%;
    margin: 15px;
  }
}
@media only screen and (max-width: 500px) {
  .lc_flex {
    display: grid;
    grid-template-columns: 100%;
    text-align: center!important;
  }
  .grid_flex {
    display: block;
  }
  .grid_contact {
    display: grid;
    grid-template-columns: 100%;
    grid-gap: 15px 0;
  }
  .grid_address {
    display: grid;
    grid-template-columns: 50% 50%;
    grid-gap: 15px 0;
  }
  .mobile_btn {
    width: 100%;
    margin: 15px 0 0;
  }
}
</style>
